// Theme
import { kooperativaTheme, komunalnaTheme } from './theme/index';
const theme = kooperativaTheme;
export { theme, komunalnaTheme, kooperativaTheme }
export { useGlobalStyles } from './theme/globalStyles';
// PKP Theme
export { pkpTheme, kpasPkpTheme } from './pkpTheme/index';

// Popup Provider
export type { PopupRecord } from './components/popup/PopupProvider';
export { PopupProvider } from './components/popup/PopupProvider';
export type { PopupModel } from './components/popup/Popup';
export { Popup, PopupWrapper, PopupFooter, PopupBody, PopupHeader } from './components/popup/Popup';

// Modal
export { Modal, getStyles } from "./components/modal/Modal";
export type { ModalProps } from "./components/modal/Modal";
export { ConfirmModal } from "./components/modal/ConfirmModal";
export type { ConfirmModalProps } from "./components/modal/ConfirmModal";
export { ModalProvider } from "./components/modal/ModalProvider";
export type { ModalProviderState, ModalProviderProps } from "./components/modal/ModalProvider";

// Filter
export { Filter } from "./components/filter/Filter";
export type { FilterField, FilterProps } from "./components/filter/Filter";
export { useFilterBase } from "./components/filter/FilterBase";
export type { FilterType, FilterFieldBase, BaseOmittedFields } from "./components/filter/FilterBase";
export { useInputFilter } from "./components/filter/InputFilter";
export type { InputFilter } from "./components/filter/InputFilter";
export { useSelectFilter } from "./components/filter/SelectFilter";
export type { SelectFilter, SelectOption } from "./components/filter/SelectFilter";
export { useMultiSelect } from "./components/filter/MultiSelectFilter";
export type { MultiSelectFilter } from "./components/filter/MultiSelectFilter";
export { useDatepickerFilter } from "./components/filter/DatepickerFilter";
export type { DatepickerFilter } from "./components/filter/DatepickerFilter";

// Snackbar Provider 
export { SnackbarProvider } from './components/snackbar/SnackbarProvider';
export type { Snackbar } from './components/snackbar/SnackbarProvider';
export { SnackbarType } from './components/snackbar/Snackbar';

// Data table
export { DataTable } from './components/dataTable/DataTable';
export { useDateColumn } from './components/dataTable/useDateColumn';
export type { DataTableProps, Column, TaskReturnValue, QueryRequiredFields } from './components/dataTable/DataTable';
export type { DateColumn } from './components/dataTable/useDateColumn';

// Tooltip Provider
export { Tooltip } from './components/tooltip/Tooltip';
export type { TooltipProps } from './components/tooltip/Tooltip';
export { TooltipProvider } from './components/tooltip/TooltipProvider';
export type { TooltipProviderProps } from './components/tooltip/TooltipProvider';

// Other components
export { TextOverflow, TextOverflowWithIcon } from './components/TextOverflow';
export type { TextOverflowProps, TextOverflowWithIconProps } from './components/TextOverflow';

export { Pagination } from './components/Pagination';
export type { PaginationProps } from './components/Pagination';

export { MobileRoute, MobileRouteWrapper, MobileRouteHeader } from './components/MobileRoute';
export type { MobileRouteProps, MobileRouteHeaderProps } from './components/MobileRoute';

export { Logo } from './components/Logo';

export { DrawerHeader, Drawer } from './components/layout/Drawer';
export type { DrawerProps } from './components/layout/Drawer';

export { AppBar } from './components/layout/AppBar';
export type { AppBarProps } from './components/layout/AppBar';

export { ContentWrapper } from "./components/layout/ContentWrapper";
export type { ContentWrapperProps } from "./components/layout/ContentWrapper";

export { FileIcon } from './components/FileIcon';
export type { FileIconProps } from './components/FileIcon';

export { OptionsDropdown } from './components/OptionsDropdown';
export type { DropdownOption, OptionsDropdownProps, DropdownOptionClickEvent } from './components/OptionsDropdown';

export { FilesUpload } from './components/FilesUpload';
export type { FilesUploadProps } from './components/FilesUpload';

export { BottomSheet } from './components/BottomSheet';
export type { BottomSheetProps } from './components/BottomSheet';

export { Camera } from "./components/Camera";
export type { CameraProps } from "./components/Camera";

export { WalletButton } from "./components/WalletButton";
export type { WalletButtonProps } from "./components/WalletButton";

export { LoadingIconButton } from "./components/LoadingIconButton";
export type { LoadindIconButtonProps } from "./components/LoadingIconButton";

export { IconButton } from "./components/IconButton";
export type { IconButtonProps } from "./components/IconButton";
export * from "./icons";

// Hooks
export { useTask } from './hooks/useTask';
export type { UseTaskReturn, AsyncFunction } from './hooks/useTask';
export { useLocalStorage } from './hooks/useLocalStorage';
export { useChangeEffect } from './hooks/useChangeEffect';
export type { UseLocalStorageReturn } from './hooks/useLocalStorage';
export { useMostRecentOptions } from './hooks/useMostRecentOptions';
export type { MostRecentOption, UseMostRecentOptionsReturn } from './hooks/useMostRecentOptions';
export { useRerender } from './hooks/useRerender';
export { useControlledState, useControlledObjectState, useControlledStateObjectReturn } from './hooks/useControlledState';
export type { Setter, UseControlledObjectStateReturn, UserControlledStateObjectReturn } from './hooks/useControlledState';
export { useAbortControllers } from './hooks/useAbortControllers';
export { useDeviceOrientation } from './hooks/useDeviceOrientation';
export { useScreenOrientationLock } from './hooks/useScreenOrientationLock';

// Enums
export { IntlLocale } from './enum/IntlLocale';

// Utils
export { removeDiacritics, formatNumber, formatPercent, capitalizeSentences, cutStringByWords, isAbsoluteUrl } from './utils/string';
export { formatDateTime, formatDate, getDaysCountBetweenDates, formatSeasons, formatDuration } from "./utils/date";
export { getQueryString, objectFromUrlSearchParams, getURLSearchParams } from './utils/query';
export type { AnyObject } from './utils/query';
export { filterObjectProperties, removeFalsyPropertiesFromObject, formatForXWWWFormUrlencoded } from "./utils/serializers";
export { parseNumber, getThemeSpacingNumber, formatNumberGroups } from "./utils/number";
export { getOSType, isPWA, OSType, AppType, BrowserType, getBrowserType, getDeviceOrientation, DeviceOrientation, isDesktop, hasCamera } from "./utils/navigator";
export { getStringEnvironmentVariable } from "./utils/environment";
export { getCookie } from './utils/cookies';
export { createSingleton } from './utils/singleton';
export type { Singleton } from './utils/singleton';
export { validateSlovakBirthNumber, extractInfoFromBirthNumber } from "./utils/birthNumber";
export { validateSlovakICO } from "./utils/ico";
export { tryFormatToInternationalPhoneNumber } from "./utils/tel";

// Types
export type { IntRange } from './types/IntRange';

// Mixins
export {
    getFluidBoxStyles, getCenterStyles, getXCenterStyles, getYCenterStyles,
    getCenteredSpaceBetweenStyles, getScreenFluidBoxStyles, getSizeStyles,
    getAbsoluteFluidBoxStyles, getFlexStyles, stretchHorizontallyParentAndChildren,
    softHide,
} from './theme/mixins';

// Focus/active state styles
export { getFocusOutlineColor, getFocusOutlineSx, FOCUS_OUTLINE_FALLBACK_COLOR } from './pkpTheme/focusStyles';
export type { FocusOutlineOptions } from './pkpTheme/focusStyles';